import React from 'react';
import {RequiresUser} from '../shared/RequiresUser';
import {FsButton} from '@finalsite/wc-react';

/*
SubmitLinks component for Fusion Forms.  Renders the "Previous", "Next", "Submit", and "Save & Finish Later" buttons.
@param form - the form object, which contains the template and pages
@param page - the current page number (1-indexed)
@param noButtons - if true, do not render any buttons
@param noLater - if true, do not render the "Save & Finish Later" button
@param noPrev - if true, do not render the "Previous" button
 */
export const SubmitLinks = ({
  form,
  page = 1,
  noButtons = false,
  noLater = false,
  noPrev = false
}) => {
  const submitText = form?.template?.pages[page - 1]?.submit_text || 'Submit';
  const lastPage = form?.template?.pages.length === page;

  return (
    <div className={'form-footer'}>
      { !noButtons && (
        <div className={'form-submit-links'}>
          <RequiresUser>
            <FsButton variant={'secondary2'}
                    name={'commit'}
                    value={'later'}
                    title={'Save & Finish Later'}
                    type={'submit'}>
              Save &amp; Finish Later
            </FsButton>
          </RequiresUser>

          {!!(!noPrev && page > 1) && (
            <FsButton variant={'secondary2'}
                    name={'commit'}
                    value={'prev'}
                    title={'< Previous'}
                    type={'submit'}>
              &lt; Previous
            </FsButton>
          )}

          <FsButton variant={'primary2'}
                  name={'commit'}
                  value={lastPage ? 'submit' : 'next'}
                  title={submitText}
                  type={'submit'}>
            {submitText}
          </FsButton>
        </div>
      )}
    </div>
  );
};
